module.exports = __webpack_public_path__ + "static/media/empty-comments@2x.bf80b153.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/sticker-comments/img/empty-comments@2x.png
// module id = 1269
// module chunks = 0